<template>
    <div class="home">
      <div class="container">
        <div class="columns is-centered">
          <div class="column">
            <div class="content">
                <h1>Application Submitted successfully</h1>
                <br>
                <callout type="success">
                    Application Submitted
                </callout>
            </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
  name: "SuccessPage",
};
</script>